import { render } from "./MedsosEdit.vue?vue&type=template&id=71ab2c8d&scoped=true&ts=true"
import script from "./MedsosEdit.vue?vue&type=script&lang=ts"
export * from "./MedsosEdit.vue?vue&type=script&lang=ts"

import "./MedsosEdit.vue?vue&type=style&index=0&id=71ab2c8d&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ab2c8d"]])

export default __exports__